import React from 'react';
import PropTypes from 'prop-types';

/**
 * Badge component for displaying status, counts, or labels
 */
const Badge = ({ 
  children, 
  variant = 'default', 
  size = 'md',
  className = '',
  animate = false,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-full';
  
  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-primary-100 text-primary-700',
    success: 'bg-success-100 text-success-700',
    warning: 'bg-warning-100 text-warning-700',
    error: 'bg-error-100 text-error-700',
    info: 'bg-blue-100 text-blue-700',
  };
  
  const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-2.5 py-1.5',
  };
  
  const animationClass = animate ? 'badge-pulse' : '';
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${animationClass} ${className}`;
  
  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

Badge.propTypes = {
  /** Content to display inside the badge */
  children: PropTypes.node.isRequired,
  /** Badge style variant */
  variant: PropTypes.oneOf(['default', 'primary', 'success', 'warning', 'error', 'info']),
  /** Badge size */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Additional CSS classes */
  className: PropTypes.string,
  /** Whether to apply a pulse animation */
  animate: PropTypes.bool,
};

export { Badge };
